import { useQuery } from '@tanstack/react-query';

import { clientsService } from '../services';

import { clientsKeys } from './useClients';

/**
 * PHI fetch with strict cache lifecycle:
 *  - `enabled` gates the actual request — pass false until the user expands the
 *    Sensitive section (no PHI is requested before the user explicitly asks for it).
 *  - `staleTime: Infinity` — once fetched, no refetch on collapse/re-expand
 *    within the same view (one audit event per page visit).
 *  - `gcTime: 0` — cache evicted immediately on unmount so PHI doesn't linger
 *    in memory after navigation.
 */
export function usePhi(clientId: string | undefined, options: { enabled: boolean }) {
  return useQuery({
    queryKey: clientsKeys.operation('phi', clientId ?? ''),
    queryFn: () => {
      if (!clientId) throw new Error('missing id');
      return clientsService.getPhi(clientId);
    },
    enabled: options.enabled && Boolean(clientId),
    staleTime: Infinity,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
